import React 					from 'react';
import ReactDOM 				from 'react-dom';

import BLComponent				from '../core/_BLComponent.jsx';
import SelectSourceOptions		from './selectSourceOptions.jsx';

export default class InventorySetInfoSection extends BLComponent 
{
	constructor (props) 
	{
		super(props);
		this.state = {
			showSmallScreenDetail: false
		}
	}
	render() {
		const {invA, invB, isEdit, invAItemNo, invASourceFrom, invBItemNo, invBSourceFrom} = this.props.data;
		return(
			<React.Fragment>	
			<div className="l-pad">
				<div className="inventory-comparison__grid-xl inventory-comparison__grid-cell-hide-small-screen l-border l-border-round">
					<div className="inventory-comparison__grid-xl-cell-span--all">
						<div className="inventory-comparison__grid-xl l-pad inventory-comparison__grid-split-y--short">

							{this.renderSetInfo(invA, invAItemNo, 0)}

							{this.renderSetInfo(invB, invBItemNo, 1)}
							
						</div>
					</div>
					{(isEdit) &&
						<div className="inventory-comparison__grid-xl-cell-span--all inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--all l-margin-x--auto l-margin-top l-margin-bottom--xl">
							<button className="btn" onClick={ () => this.props.func.toggleInvSetEditMode() }>Cancel</button>
							<button className="btn btn--cta l-margin-left--xl" onClick={ () => this.props.func.updateSetData() }>Update</button>
						</div>
					}
					
				</div>
			</div>
			{this.renderSmallScreen(invAItemNo, invASourceFrom, invBItemNo, invBSourceFrom)}
			</React.Fragment>
		)
	}

	renderSmallScreen(invAItemNo, invASourceFrom, invBItemNo, invBSourceFrom) {
		const {invA, invB, isEdit} = this.props.data;
		if (isEdit)
		{
			return(
				<div className="l-pad l-border--bottom inventory-comparison__grid-cell-show-small-screen">
					<div className="inventory-comparison__grid-xl">
						<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--all text--title text--bold">
							Inventory A
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-xl-cell-span--half">
							<div>Set ID</div>
							<div className="l-full-width"><input type="text" className="text-input text-input--sm l-full-width" value={ invAItemNo } onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInv( e.target.value, 0 )}/></div>
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-xl-cell-span--half">
							<div>Source</div>
							<select className="select select--tight l-full-width" value={invASourceFrom} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvSourceFrom( e.target.value, 0 )}>
								<option value="0">BrickLink data</option>
                                <option value="1">LEGO data</option>
							</select>
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--all text--title text--bold l-margin-top">
							Inventory B
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-xl-cell-span--half">
							<div>Set ID</div>
							<div className="l-full-width"><input type="text" className="text-input text-input--sm l-full-width" value={ invBItemNo } onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInv( e.target.value, 1 )}/></div>
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__grid-xl-cell-span--half">
							<div>Source</div>
							<select className="select select--tight l-full-width" value={invBSourceFrom} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvSourceFrom( e.target.value, 1 )}>
								<option value="0">BrickLink data</option>
                                <option value="1">LEGO data</option>
							</select>
						</div>
						<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--all l-margin-top--xl text--right">
							<span><button className="btn" onClick={ () => this.props.func.toggleInvSetEditMode() }>Cancel</button></span>
							<span className="l-margin-left--l"><button className="btn btn--cta" onClick={ () => this.props.func.updateSetData() }>Update</button></span>
						</div>
					</div>
				</div>
			)
		}
		else if ( (invA != null) && (invB != null) )
		{
			return(
				<div className="l-pad l-border--bottom inventory-comparison__grid-cell-show-small-screen">
					<div className="inventory-comparison__grid-xl">
						<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--all ">
							<div className="l-flex l-split">
								<div className="inventory-comparison__section-set-small">
									<div className="l-flex">
										{this.renderSmallSetDetail(invA, 0)}
										{this.renderSmallSetDetail(invB, 1)}
									</div>
								</div>
								<div onClick={()=>this.toggleSmallScreenDetail()}>
									{this.state.showSmallScreenDetail?<i className="fas fa-chevron-up"></i>:<i className="fas fa-chevron-down"></i>}
								</div>
							</div>

						</div>
					</div>
				</div>
			)
		}
	}

	renderSmallSetDetail(inv, target) {
		const title = (target == 0)? "Inv A":"Inv B";
		const {invASourceFrom, invBSourceFrom} = this.props.data;
		const invSourceFrom = (target == 0)? invASourceFrom:invBSourceFrom;
		const sourceFrom = (invSourceFrom == 0)?"BrickLink":"Lego";

		return(
			<section className={"inventory-comparison__set-small " + ( target == 1 ? "l-margin-left--l":"" )}>
				<div className="l-flex">
					<div className="inventory-comparison__set-image-small" >
						<img src={inv.setImg} />
					</div>
					<div className="l-margin-left">
						<div className="text--small-title">
							<strong>{title}</strong>
						</div>
						<div>{ ( (inv != null) && ( inv.isPending ) ) && <span className="l-margin-right--sm"><i className="fas fa-exclamation-circle"></i></span>}{inv.setId}{ (inv.setSeq != "")?"-" + inv.setSeq:"" }</div>
					</div>
				</div>
				{ this.state.showSmallScreenDetail && 
					<section>
						<div>{inv.title}</div>
						{ ( (inv != null) && ( inv.isPending ) ) && <div>Status: <strong>Pending</strong></div>}
						<div>Source: <strong>{ sourceFrom } data</strong> <span className="l-margin-left--sm"><i className="far fa-edit" onClick={()=>this.props.func.toggleInvSetEditMode()}></i></span></div>
					</section>
				}
			</section>
		)
	}

	renderPending() {
		return(  
			<React.Fragment>
				<span className="l-margin-left"><i className="fas fa-exclamation-circle"></i></span><span className="inventory-comparison__inv-pending-msg"> Pending</span>
			</React.Fragment>
		)	
	}

	renderSetInfo(inv, invItemNo, target) {
		const invTitle = (target == 0 )?"Inventory A":"Inventory B";
		const invTitleSm = (target == 0 )?"Inv A":"Inv B";
		return(
			<div className="inventory-comparison__grid-cell inventory-comparison__inv-section inventory-comparison__grid-xl-cell-span--half l-margin-x--auto">
				<div className="inventory-comparison__set-image-section">
					<div>
						<span className="text--small-title text--bold">{invTitle}</span>
						{ ( (inv != null) && ( inv.isPending ) ) && 
							this.renderPending()
						}
					</div> 
					{ this.renderSetTitle(inv) }
					{ this.renderSetImg(inv, target) }
					{ this.renderSetDetail(inv, invItemNo, target) }
				</div>
			</div>
		)
	}

	renderSetTitle( inv ) {
		if ( (inv != null) && (inv.title != "") ) {
			return (
				<div className="l-margin-top--sm">{inv.title}</div>
			)
		}
		else
		{
			return (
				<div className="l-margin-top--sm inventory-comparison__text-color--darkest48">Name unavailable</div>
			)
		}
	}

	renderSetImg(inv, target) {
		 
		if (inv == null) {
			return(  
				<div className="inventory-comparison__empty-image"></div> 
			)
		}
		
		if ( (inv.setImg != null) && (inv.setImg != "") )  
		{
			return(
				<div className="l-margin-top">
					<img id={"setImg_" + target} className="inventory-comparison__inv-set-img" src={inv.setImg} onError={()=>this.setImgError(target) }/>
					<div id={"setImgErr_" + target} className="l-hide">
						<div className="l-margin-top inventory-comparison__div-align-center">  
							<div className="inventory-comparison__empty-image inventory-comparison__div-align-center">
								<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
								    <path fillRule="evenodd" clipRule="evenodd" d="m15.248 5.091-.312-.312a1.5 1.5 0 0 0-1.06-.44H7.5c-.828.003-1.5.675-1.5 1.503v8.497l1.5-1.5V5.842h4.999V7.84l1.5-1.5v-.376l.188.188 1.06-1.06zM8.656 17.34l2.421-2.42.422.42 2.734-2.733a.375.375 0 0 1 .53 0l.735.734v4H8.656zM7.5 18.497v.343h8.998V9.841h-.343l1.786-1.786c.037.132.057.27.057.408V18.84a1.5 1.5 0 0 1-1.5 1.5H7.5a1.5 1.5 0 0 1-1.42-1.016 1.992 1.992 0 0 0 1.163-.57l.257-.257zm2.934-8.591A1.499 1.499 0 0 0 8.5 11.34c0 .15.022.297.064.434l1.87-1.87z" fill="#0A1E32"/>
								    <path stroke="#000" strokeWidth="2" strokeLinecap="round" d="M18 5.253 4.414 18.839"/>
								</svg>
							</div> 
						</div>
					</div>
				</div>
			)
		}
		else
		{
			return(
				<div className="l-margin-top inventory-comparison__div-align-center">  
					<div className="inventory-comparison__empty-image inventory-comparison__div-align-center">
						<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						    <path fillRule="evenodd" clipRule="evenodd" d="m15.248 5.091-.312-.312a1.5 1.5 0 0 0-1.06-.44H7.5c-.828.003-1.5.675-1.5 1.503v8.497l1.5-1.5V5.842h4.999V7.84l1.5-1.5v-.376l.188.188 1.06-1.06zM8.656 17.34l2.421-2.42.422.42 2.734-2.733a.375.375 0 0 1 .53 0l.735.734v4H8.656zM7.5 18.497v.343h8.998V9.841h-.343l1.786-1.786c.037.132.057.27.057.408V18.84a1.5 1.5 0 0 1-1.5 1.5H7.5a1.5 1.5 0 0 1-1.42-1.016 1.992 1.992 0 0 0 1.163-.57l.257-.257zm2.934-8.591A1.499 1.499 0 0 0 8.5 11.34c0 .15.022.297.064.434l1.87-1.87z" fill="#0A1E32"/>
						    <path stroke="#000" strokeWidth="2" strokeLinecap="round" d="M18 5.253 4.414 18.839"/>
						</svg>
					</div> 
				</div>
			)
		}
		
	}

	renderSetDetail(inv, invItemNo, target) {
		const isEdit = this.props.data.isEdit;

		if (inv != null) {
			if (!isEdit) {
				return(
					<div className="l-flex l-margin-top--l">
						<div>Set ID: <strong>{inv.setId}{ (inv.setSeq != "")?"-" + inv.setSeq:"" }</strong></div>
						<div className="l-margin-left--l">Source: <strong>{inv.source} data</strong></div>
						<div className="l-margin-left--l l-cursor-pointer"><i className="far fa-edit" onClick={()=>this.props.func.toggleInvSetEditMode()}></i></div>
					</div>
				)
			}
			else
			{
				return(
					<section className="l-flex l-margin-top">
						<div>
							<div className="text--right inventory-comparison__input-row-height l-flex l-column l-center-v"><div>Set ID</div></div>
							<div className="text--right inventory-comparison__input-row-height l-flex l-column l-center-v">Source</div>
						</div>
						<div className="l-margin-left">
							<div className="text--left inventory-comparison__input-row-height l-flex l-column l-center-v"><input className="text-input text-input--sm l-full-width" type="text" value={invItemNo} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInv( e.target.value, target )}/></div>
							<div className="text--left inventory-comparison__input-row-height l-flex l-column l-center-v">
								<select className="select select--tight l-full-width" value={target==0?this.props.data.invASourceFrom:this.props.data.invBSourceFrom} onKeyUp={(e) => this.checkEnterSubmit(e)} onChange={(e) => this.props.func.changeInvSourceFrom( e.target.value, target )}>
									<option value="0">BrickLink data</option>
									<option value="1">LEGO data</option>
								</select>
							</div> 
						</div>
					</section>
				)
			}
		}
	}

	checkEnterSubmit(e)
	{
		if (e.keyCode == 13) {
        	this.props.func.updateSetData();
    	}
	} 

	setImgError(target) {
		$("#setImg_" + target).hide();
		$("#setImgErr_" + target).show();
	}

	toggleSmallScreenDetail() {
		this.setState({showSmallScreenDetail:!this.state.showSmallScreenDetail})
	}
	
}